module.exports = __webpack_public_path__ + "media/images/2024_fanclub_card_family-e83a9054774dd60c3b045b515267e8ce.png";